import React, { Component } from "react";
import { connect } from "react-redux";
import Footer from "../../../GlobalComponents/Footer";
import Navbar from "../Navbar";
import KitNavbar from "./KitNavbar";
import { Link, Redirect } from "react-router-dom";
import Pagination from "react-js-pagination";
import { Modal, ModalBody, ModalHeader, ModalFooter, Input } from "reactstrap";
import { setActions } from "../../../../actions";
import { ReactComponent as Spinner } from "../../../../assets/images/Spinner-1s-200px.svg";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setService, userService } from "../../../../services";
import QuarantineModal from "./Modal/quarantineModal";
import MissingStockModal from "./Modal/missingStockModal";
import dateFormat from "dateformat";
import * as excelJs from "exceljs";
import moment from "moment";

async function downloadMissingStockExcel(data) {
  const workbook = new excelJs.Workbook();
  const ws = workbook.addWorksheet("Test Worksheet");
  const headers = [
    "Set Name",
    "Missing Stock Status",
    "Missing Stock Date",
    "Missing Stock Comment",
    "Updated By",
  ];

  const header1Row = ws.addRow(headers);
  header1Row.eachCell((cell) => {
    cell.font = {
      bold: true,
      size: 11,
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { wrapText: true };
  });

  data?.length &&
    data.forEach((item) => {
      console.log("nnnnn", item);
      const rowData = [
        item.set_name,
        item.missing_stock_check ? "Checked" : "Unchecked",
        item.missing_stock_check_date
          ? dateFormat(item.missing_stock_check_date, "mmmm dd, yyyy")
          : !item.missing_stock_check
          ? dateFormat(item.updatedAt, "mmmm dd, yyyy")
          : "",
        item.missing_stock_comment,
        item?.updatedByUser
          ? item?.updatedByUser?.first_name +
            " " +
            item?.updatedByUser?.last_name
          : "",
      ];

      const dataRow = ws.addRow(rowData);

      dataRow.eachCell((cell) => {
        cell.alignment = { wrapText: true };
      });
    });

  ws.columns.forEach((column) => {
    column.width = 30;
  });

  ws.eachRow((row, rowNumber) => {
    if (rowNumber > 1) {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });
    }
    if (rowNumber === 1) {
      row.eachCell((cell) => {
        cell.font = {
          bold: true,
          size: 13,
        };
      });
    }
  });

  const excelBlob = await workbook.xlsx.writeBuffer();
  const excelUrl = URL.createObjectURL(
    new Blob([excelBlob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
  );

  const link = document.createElement("a");
  link.href = excelUrl;
  link.download = "Missing Stock History";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(excelUrl);
  document.body.removeChild(link);
}

async function downloadQuarantineExcel(data) {
  const workbook = new excelJs.Workbook();
  const ws = workbook.addWorksheet("Test Worksheet");
  const headers = [
    "Set Name",
    "Quarantine Set Status",
    "Quarantine Set Date",
    "Quarantine Set Comment",
    "Updated By",
  ];

  const header1Row = ws.addRow(headers);
  header1Row.eachCell((cell) => {
    cell.font = {
      bold: true,
      size: 11,
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.alignment = { wrapText: true };
  });

  data?.length &&
    data.forEach((item) => {
      const rowData = [
        item.set_name,
        item.quarantine_check ? "Checked" : "Unchecked",
        item.quarantine_check_date
          ? dateFormat(item.quarantine_check_date, "mmmm dd, yyyy")
          : !item.quarantine_check
          ? dateFormat(item.updatedAt, "mmmm dd, yyyy")
          : "",
        item.quarantine_check_comment,
        item?.updatedByUser
          ? item?.updatedByUser?.first_name +
            " " +
            item?.updatedByUser?.last_name
          : "",
      ];

      const dataRow = ws.addRow(rowData);

      dataRow.eachCell((cell) => {
        cell.alignment = { wrapText: true };
      });
    });

  ws.columns.forEach((column) => {
    column.width = 30;
  });

  ws.eachRow((row, rowNumber) => {
    if (rowNumber > 1) {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });
    }
    if (rowNumber === 1) {
      row.eachCell((cell) => {
        cell.font = {
          bold: true,
          size: 13,
        };
      });
    }
  });

  const excelBlob = await workbook.xlsx.writeBuffer();
  const excelUrl = URL.createObjectURL(
    new Blob([excelBlob], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    })
  );

  const link = document.createElement("a");
  link.href = excelUrl;
  link.download = "Quarantine Set History";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  URL.revokeObjectURL(excelUrl);
  document.body.removeChild(link);
}

const statusOptions = [
  { value: "all", label: "All" },
  { value: "missing_stock", label: "Missing Stocks" },
  { value: "quarantine", label: "Quarantine" },
];

const visibilityOptions = [
  { value: "all", label: "All" },
  { value: "Pending", label: "Pending" },
  { value: "Active", label: "Active" },
  { value: "Deactive", label: "Deactive" },
  { value: "Approve", label: "Approved" },
];

class Kits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("user")),
      deleteModal: false,
      id: "",
      search: "",
      activePage: 1,
      limit: 50,
      totalItemsCount: 10,
      status: "all",
      visibility: "all",
      selectedFilter: { value: "all", label: "All" },
      selectedStatus: { value: "all", label: "All" },
      quarantine_check: false,
      missing_stock_check: false,
      openQuarantineModal: false,
      openMissingStockModal: false,
      missing_stock_date: new Date(),
      missing_stock_comment: "",
      quarantine_date: new Date(),
      quarantine_comment: "",
      counter: 0,
      totalCounter: 0,
      resetDates: "",
      dataItem: [],
      openApproveModal: false,
    // Approval Form Data
      approveData: {},
      receivedBy: "",
      receivedDate: moment().format("YYYY-MM-DD"),
      receivedChecked: false,
      usersList: [],
      selectedUser: null,
      errors: {} ,
      checkApprovalPermission: false,
      isLoading: false,
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.deleteModalOpen = this.deleteModalOpen.bind(this);
    this.deleteModalClose = this.deleteModalClose.bind(this);
    this.QuarantineModalOpen = this.QuarantineModalOpen.bind(this);
    this.handleQuarantineCheck = this.handleQuarantineCheck.bind(this);
    this.handleMissingStockCheck = this.handleMissingStockCheck.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.setMissingStock = this.setMissingStock.bind(this);
    this.setQuarantine = this.setQuarantine.bind(this);
    this.handleVisiblity = this.handleVisiblity.bind(this);
    this.updateVisibility = this.updateVisibility.bind(this);

    this.QuarantineModalClose = this.QuarantineModalClose.bind(this);
    this.MissingStockModalClose = this.MissingStockModalClose.bind(this);
    this.handleMissingStockSubmit = this.handleMissingStockSubmit.bind(this);
    this.handleQuarantineSubmit = this.handleQuarantineSubmit.bind(this);
    this.resetCounter = this.resetCounter.bind(this);
    this.handleApproveSubmit = this.handleApproveSubmit.bind(this);
  }

  handlePageChange(pageNumber) {
    if (pageNumber !== this.state.activePage) {
      this.setState(
        {
          activePage: pageNumber,
        },
        () => {
          this.getSetsList();
        }
      );
      window.scrollTo({ top: 0 });
    }
  }

  handleVisiblity(e) {
    this.setState(
      {
        visibility: e.value,
        selectedStatus: e,
        activePage: 1,
      },
      () => {
        this.getSetsList();
      }
    );
  }

  validateApproveForm = () => {
    let errors = {};
  
    if (!this.state.receivedChecked) {
      errors.receivedChecked = "Please confirm this checkbox";
    }
  
    if (!this.state.selectedUser) {
      errors.selectedUser = "Please select user";
    }
  
    if (!this.state.receivedDate) {
      errors.receivedDate = "Please select date";
    }
  
    this.setState({ errors });
  
    return Object.keys(errors).length === 0;
  };

  handleOpenApproveModal = (setData) => {
    this.setState({
      openApproveModal: true,
      approveData: setData,
      selectedUser: null,
      receivedDate: moment().format("YYYY-MM-DD"),
      receivedChecked: false,
      errors: {}
    });
  
    // 👇 API call only when needed
    if (this.state.usersList.length === 0) {
      userService
        .getUsersListForSetApproval({
          search: "",  
        })
        .then((res) => {
          if (res.status === 200) {
            const users = res.data.map((u) => ({
              value: u._id,
              label: u.first_name + " " + u.last_name,
            }));
  
            this.setState({ usersList: users });
          }
        })
        .catch((err) => {
          console.log("User list error:", err);
        });
    }
  };

  handleApproveSubmit() {
    if (!this.validateApproveForm()) return;

    const {selectedUser, receivedDate, receivedChecked, approveData} = this.state;

    // Validation
    if (!receivedChecked || !selectedUser || !receivedDate) {
      toast.error("All fields are mandatory");
      return;
    }


    // ✅ API call
    setService
    .updateSetStatus({
      id: approveData._id,
      status: "Active",
      receivedBy: selectedUser.value,
      receivedDate,
    })
    .then(() => {
      this.setState({
        openApproveModal: false,
        receivedBy: "",
        receivedDate: moment().format("YYYY-MM-DD"),
        receivedChecked: false,
        selectedUser: null,  
      });
      this.getSetsList();
    });
  }

  updateVisibility(id, status) {
    console.log("updateVisibility", id, status);
    setService
      .updateSetStatus({ status: status, id: id })
      .then(() => this.getSetsList());
  }

  handlePageStates(activePage, totalItemsCount, limit) {
    this.setState({
      activePage: activePage,
      totalItemsCount: totalItemsCount,
      limit: limit,
    });
  }

  getSetsList() {

    this.props.dispatch(
      setActions.getSetsList({
        search: this.state.search,
        page: this.state.activePage,
        limit: this.state.limit,
        filter: this.state.status,
        status: this.state.visibility,
      })
    );

  }

  handleSearch(val) {
    this.setState(
      {
        search: val,
        activePage: 1,
      },
      () => {
        this.getSetsList();
      }
    );
  }

  deleteModalOpen() {
    this.setState({ deleteModal: true });
  }

  deleteModalClose() {
    this.setState({
      deleteModal: false,
      id: "",
    });
  }

  QuarantineModalOpen() {
    this.setState({ openQuarantineModal: true });
  }

  QuarantineModalClose() {
    this.setState({
      openQuarantineModal: false,
      id: "",
    });
  }

  handleOpenQuarantineModal(e, id) {
    e.preventDefault();
    this.setState({
      id: id,
      error: false,
    });
    this.QuarantineModalOpen();
  }

  MissingStockModalOpen() {
    this.setState({ openMissingStockModal: true });
  }

  MissingStockModalClose() {
    this.setState({
      openMissingStockModal: false,
    });
  }

  handleOpenMissingStockModal(e, id) {
    e.preventDefault();
    this.setState({
      id: id,
      error: false,
    });
    this.MissingStockModalOpen();
  }

  handleDelete(e, id) {
    e.preventDefault();
    this.setState({
      id: id,
      error: false,
    });
    this.deleteModalOpen();
  }

  handleDownloadQuarantineHistory(e, id, set) {
    e.preventDefault();
    console.log("download History api", id, "ll", set);
    let data = [];
    setService
      .getQuarantineHistory({ id: id, set_name: set })
      .then((res) => {
        if (res.status === 200) {
          this.getSetsList();
          downloadQuarantineExcel(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    console.log("daata", data);
  }

  handleDownloadMissingStockHistory(e, id, set) {
    e.preventDefault();
    console.log("download History api", id, "ll", set);
    let data = [];
    setService
      .getMissingStockHistory({ id: id, set_name: set })
      .then((res) => {
        if (res.status === 200) {
          this.getSetsList();
          downloadMissingStockExcel(res.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    console.log("daata", data);
  }

  doDelete() {
    this.setState({
      error: true,
    });
    this.props.dispatch(setActions.delete({ id: this.state.id }));
  }

  handleQuarantineCheck(event, item) {
    const checked = event.target.checked;
    console.log("item", item);
    this.setState({
      dataItem: item,
      id: item._id,
      quarantine_check: checked,
    });

    if (checked) {
      this.setState({
        openQuarantineModal: true,
      });
    } else {
      this.setQuarantine(false, item);
    }
  }

  handleMissingStockCheck(event, item) {
    const checked = event.target.checked;

    this.setState({
      dataItem: item,
      id: item._id,
      missing_stock_check: checked,
    });

    if (checked) {
      this.setState({
        openMissingStockModal: true,
      });
    } else {
      this.setMissingStock(false, item);
    }
  }

  handleMissingStockSubmit(date, comment) {
    console.log("Missing stock Selected Date:", date);
    console.log("Missing stock Comment:", comment);
    console.log("Missing stock ID:", this.state.id);
    this.setState(
      {
        missing_stock_check: true,
        missing_stock_date: date,
        missing_stock_comment: comment,
        openMissingStockModal: false,
      },
      () => {
        this.setMissingStock(true, this.state.dataItem);
      }
    );
  }

  setMissingStock(val, item) {
    console.log("aaaaazzzzzz", item);
    this.setState({
      missing_stock_check: val,
    });
    const payloadMisstock = {
      set_name: item.set_name,
      dataItem: item,
      id: item._id,
      missing_stock_check: val,
      missing_stock_comment: this.state.missing_stock_comment,
      missing_stock_check_date: this.state.missing_stock_date,
      type: "missing_stock_check",
    };

    setService
      .updateMissingAndQuarantineStock(payloadMisstock)
      .then((res) => {
        if (res.status === 200) {
          this.getSetsList();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  setQuarantine(val, item) {
    console.log("ajajaj", item);
    this.setState({
      quarantine_check: val,
    });
    const payloadQuarantine = {
      id: item._id,
      set_name: item.set_name,
      quarantine_check: val,
      quarantine_check_comment: this.state.quarantine_comment,
      quarantine_check_date: this.state.quarantine_date,
      type: "quarantine_check",
    };
    console.log("payloadQuarantine", payloadQuarantine);
    setService
      .updateMissingAndQuarantineStock(payloadQuarantine)
      .then((res) => {
        if (res.status === 200) {
          this.getSetsList();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(nextProps);

    if (nextProps.refreshList == true || nextProps.redirect == true) {
      this.setState(
        {
          activePage: this.state.activePage,
        },
        () => {
          this.getSetsList();
        }
      );
    }

    if (
      nextProps.activePage != "" &&
      nextProps.totalItemsCount != "" &&
      nextProps.limit != ""
    ) {
      this.handlePageStates(
        nextProps.activePage,
        nextProps.totalItemsCount,
        this.state.limit
      );
    }

    if (nextProps.deleteModal == false) {
      this.deleteModalClose();
    }

    if (nextProps.error !== "") {
      if (nextProps.error !== undefined) {
        if (nextProps.error.description) {
          toast.error(nextProps.error.description[0], {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }

        if (nextProps.error.kitID) {
          toast.error(nextProps.error.kitID[0], {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }

        if (nextProps.error.set_name) {
          toast.error(nextProps.error.set_name[0], {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
        }
      }
    }
  }

  handleStatus(e) {
    this.setState(
      {
        status: e.value,
        selectedFilter: e,
        activePage: 1,
      },
      () => {
        this.getSetsList();
      }
    );
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });
    this.getSetsList();

  }

 getXlsxDataForSets = async () => {
    if (this.state.isLoading) return; // extra safety
    this.setState({ isLoading: true }); //  disable button

    try {
        const res = await setService.getSetsExport({
          search: this.state.search,
          page: this.state.activePage,
          limit: this.state.limit,
          filter: this.state.status,
          status: this.state.visibility,
        });
        if(res.status){
            this.handleExportClick(res?.data);
        }
    } catch (error) {
        console.error("Error: ", error);
    } finally {
      this.setState({ isLoading: false }); //  re-enable button
    }
    
};

addNewlines = (string, interval) => {
    let result = "";
    for (let i = 0; i < string.length; i++) {
      if (i > 0 && i % interval === 0) {
        result += "\n";
      }
      result += string[i];
    }
    return result;
};

handleExportClick = async (data) => {
    const workbook = new excelJs.Workbook();
    const ws = workbook.addWorksheet("Sets Export Report");
    
    const header1 = [
        "Set Name",
        "Approved By",
        "Approved Date"
    ];

    const header1Row = ws.addRow(header1);
    header1Row.eachCell((cell) => {
        cell.font = {
            bold: true,
            size: 11,
        };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCC0DA" }
        };
        cell.border = {
            top: {style:"thin"},
            left: {style:"thin"},
            bottom: {style:"thin"},
            right: {style:"thin"}
        };
    });

    if (data?.length) {
        data && data.map(item => {
            const rowData = [
                item?.sets?.set_name,
                item?.sets?.receivedByUser?.length > 0
                ? item.sets.receivedByUser[0].first_name + " " + item.sets.receivedByUser[0].last_name
                : "-",
                item?.sets?.receivedDate
                ? moment(item.sets.receivedDate).format("ddd, MMMM Do, YYYY")
                : "-"

            ];
            let row = ws.addRow(rowData);
            ws.getCell("C"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
            ws.getCell("D"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
            ws.getCell("J"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
            ws.getCell("E"+row?._number).alignment = { vertical: "bottom", horizontal: "left" };
        });
    }

    // Iterate through each column to calculate and set width
    ws.columns.forEach((column, columnIndex) => {
        let maxLength = 0;
        // Start from the third row (index 2) to skip the header row
        for (let rowIndex = 3; rowIndex <= ws.rowCount; rowIndex++) {
            const cellValue = ws.getCell(rowIndex, columnIndex + 1).value;
            if (columnIndex + 1 === 3 || columnIndex + 1 === 5 || columnIndex + 1 === 10 || columnIndex + 1 === 4) {
              if (typeof cellValue === "string") {
                  const array = cellValue.split("\n");
                  array.forEach(str => {
                      if (str.length > maxLength) {
                          maxLength = str.length;
                      }
                  });
              } else if (cellValue) {
                  const length = cellValue.toString().length;
                  if (length > maxLength) {
                      maxLength = length;
                  }
              }
          } else {
              if (cellValue && cellValue.toString().length > maxLength) {
                  maxLength = cellValue.toString().length;
              }
          }
        }
        // Set the width of the column based on the maximum length of its content
        column.width = maxLength < 20 ? 20 : maxLength + 2; // Add padding
    });

    ws.eachRow((row, rowNumber) => {
        if (rowNumber > 1) {
            row.eachCell((cell) => {
                cell.border = {
                    top: { style: "thin", color: { argb: "000000" } },
                    left: { style: "thin", color: { argb: "000000" } },
                    bottom: { style: "thin", color: { argb: "000000" } },
                    right: { style: "thin", color: { argb: "000000" } },
                };
            });
        }
    });

    const excelBlob = await workbook.xlsx.writeBuffer();
    const excelUrl = URL.createObjectURL(
        new Blob([excelBlob], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    );
    // setIsLoading(false);
    const link = document.createElement("a");
    link.href = excelUrl;
    link.download = "sets-export-report";
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(excelUrl);
    document.body.removeChild(link);  
};

  handleQuarantineSubmit(date, comment, item) {
    console.log("llll", item);
    const { dataItem } = this.state;

    this.setState(
      {
        quarantine_check: true,
        quarantine_date: date,
        quarantine_comment: comment,
        openQuarantineModal: false,
      },
      () => {
        this.setQuarantine(true, dataItem);
      }
    );
  }

  handleCounter(val) {
    this.setState({
      counter: val,
    });
  }

  resetCounter(id) {
    console.log("zzzz", id);
    this.setState({
      counter: 0,
    });
    setService.resetCounter({ setId: id }).then(() => this.getSetsList());
  }

  

  render() {
    if (!this.state.user) {
      return <Redirect to="/" />;
    }
    if (this.state.user.data.user_role !== "admin") {
      return <Redirect to="/" />;
    }
    const { setsList, loading, error, checkApprovalPermission } = this.props;
    return (
      <div>
        <ToastContainer />
        <Navbar activePage="kits" />
        <div className="container-fluid">
          <div className="pt-4 row align-items-center">
            <div className="col-md-3">
              <div className="sub-menu">
                <KitNavbar activePage="sets" />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-search">
                <Input
                  className="form-control mr-sm-2"
                  type="text"
                  placeholder="Search.."
                  value={this.state.search}
                  onChange={(e) => this.handleSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-2">
              <form className="form-search my-1">
                <Select
                  defaultValue={this.state.selectedFilter}
                  onChange={this.handleStatus}
                  options={statusOptions}
                />
              </form>
            </div>
            <div className="col-md-2">
              <form className="form-search my-1">
                <Select
                  defaultValue={this.state.selectedStatus}
                  onChange={this.handleVisiblity}
                  options={visibilityOptions}
                />
              </form>
            </div>
            <button
                type="button"
                onClick={() =>
                  !loading && !this.state.isLoading
                    ? this.getXlsxDataForSets()
                    : null
                }
                disabled={loading || this.state.isLoading} //  disable click
                // title={loading ? "Please wait..." : "Export"} //  hover text
                style={{
                  cursor: loading || this.state.isLoading ? "not-allowed" : "pointer",
                  opacity: loading || this.state.isLoading ? 0.6 : 1
                }}
                id="ReportDownload"
                className="btn btn-default mr-2 my-1"
              >
                {" "}
                Export{" "}
              </button>
              {/* col-md-2 text-right */}
            <div className="float-right"> 
              <Link to="/admin/sets" className="btn btn-primary add_option">
                <i className="fa fa-plus"></i> <span>Add New</span>
              </Link>
            </div>
          </div>
          <div id="table-scroll" className="table-scroll mt-4">
            <table id="main-table" className="main-table">
              <thead>
                <tr>
                  <th scope="col">Set Name / Added Date</th>
                  <th scope="col" className="" style={{ minWidth: "120px" }}>
                    Kit
                  </th>
                  <th scope="col" style={{ width: "90px" }}>
                    Counter
                  </th>
                  <th scope="col">Date of Last Reset</th>
                  <th scope="col" style={{ width: "90px" }}>
                    Total Counter
                  </th>
                  <th scope="col">Missing Stock</th>
                  {/* <th scope="col">Missing Stock Comment</th> */}
                  <th scope="col">Quarantine</th>
                  {/* <th scope="col">Date</th> */}
                  <th scope="col" style={{ width: "200px" }}>
                    Missing Stock (Date/Name/Comment)
                  </th>
                  <th scope="col" style={{ width: "200px" }}>
                    Quarantine (Date/Name/Comment)
                  </th>
                  <th scope="col"></th>
                  <th scope="col">Approved By</th>  
                  <th scope="col">Status</th>
                  <th scope="col" className="text-right" width="100">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {setsList &&
                  setsList.map((set) => {
                    return (
                      <tr key={set.sets._id}>
                        <td>
                          <div className="">
                            <span>
                              <a href="#">
                                <strong>{set.sets.set_name}</strong>
                              </a>
                            </span>{" "}
                            <br />
                            <span style={{ fontSize: "12px" }}>
                              {dateFormat(set.sets.createdAt, "mmm dS, yyyy")}
                            </span>
                          </div>
                        </td>
                        <td className="">{set.sets.kitID[0].name}</td>
                        <td>
                          <Input
                            type="number"
                            value={
                              set.sets.manualCounter
                                ? set.sets.manualCounter
                                : 0
                            }
                            onChange={(val) => this.handleCounter(val)}
                            className="form-control"
                            readOnly
                            style={{ width: "90%", backgroundColor: "#fff" }}
                          />
                          <p
                            style={{
                              fontSize: "13px",
                              textAlign: "center",
                              marginTop: "5px",
                              cursor: "pointer",
                              color: "blue",
                              marginLeft: "20px",
                            }}
                            onClick={() => this.resetCounter(set.sets._id)}
                          >
                            Reset
                          </p>
                        </td>
                        <td>
                          {set.sets.lastResetDate
                            ? dateFormat(set.sets.lastResetDate, "mmm dS, yyyy")
                            : ""}
                        </td>
                        <td>
                          <Input
                            type="number"
                            value={
                              set.sets.totalCounter ? set.sets.totalCounter : 0
                            }
                            className="form-control"
                            readOnly
                            style={{ width: "90%", backgroundColor: "#fff" }}
                          />
                        </td>

                        <td style={{ minHeight: "44px" }}>
                          <Input
                            className="form-check-input mx-1"
                            type="checkbox"
                            value={
                              set?.sets?.missing_stock_check ? true : false
                            }
                            checked={set?.sets?.missing_stock_check || false}
                            onChange={(e) =>
                              this.handleMissingStockCheck(e, set.sets)
                            }
                          />
                        </td>
                        <td style={{ minHeight: "44px" }}>
                          <Input
                            className="form-check-input mx-1"
                            type="checkbox"
                            checked={set?.sets?.quarantine_check || false}
                            value={set?.sets?.quarantine_check ? true : false}
                            onChange={(e) =>
                              this.handleQuarantineCheck(e, set.sets)
                            }
                          />
                        </td>
                        <td>
                          {set?.sets?.missing_stock_check === true ? (
                            <>
                              {set?.sets?.latestMissingStockHistory?.length >
                                0 && (
                                <>
                                  {set?.sets?.latestMissingStockHistory
                                    ?.length > 0 && (
                                    <div>
                                      <span>
                                        {dateFormat(
                                          set.sets.latestMissingStockHistory[0]
                                            .missing_stock_check_date,
                                          "mmm dS, yyyy"
                                        )}
                                      </span>
                                      <br />
                                    </div>
                                  )}
                                  {set?.sets?.latestMissingStockHistory[0]
                                    ?.updatedByUser?.length > 0 && (
                                    <i>
                                      {`${set?.sets?.latestMissingStockHistory[0]?.updatedByUser[0]?.first_name} ${set?.sets?.latestMissingStockHistory[0]?.updatedByUser[0]?.last_name}`}
                                    </i>
                                  )}
                                  {set?.sets?.latestMissingStockHistory[0]
                                    ?.missing_stock_comment && (
                                    <div style={{fontSize:14,marginTop:8}}>
                                      {
                                        set.sets.latestMissingStockHistory[0]
                                          .missing_stock_comment
                                      }
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <div></div>
                          )}
                        </td>

                        <td>
                          {set?.sets?.quarantine_check === true ? (
                            <>
                              {set?.sets?.latestQuarantineHistory?.length >
                                0 && (
                                <>
                                  {set?.sets?.latestQuarantineHistory[0]
                                    ?.quarantine_check_date && (
                                    <div>
                                      {/* <br /> */}
                                      <span>
                                        {dateFormat(
                                          set.sets.latestQuarantineHistory[0]
                                            .quarantine_check_date,
                                          "mmm dS, yyyy"
                                        )}
                                      </span>
                                      <br />
                                    </div>
                                  )}
                                  {set?.sets?.quarantine_check === true &&
                                    set?.sets?.latestQuarantineHistory?.length >
                                      0 &&
                                    set?.sets?.latestQuarantineHistory[0]
                                      ?.updatedByUser?.length > 0 && (
                                      <i>
                                        {`${set?.sets?.latestQuarantineHistory[0]?.updatedByUser[0]?.first_name} ${set?.sets?.latestQuarantineHistory[0]?.updatedByUser[0]?.last_name}`}
                                      </i>
                                    )}
                                  {set?.sets?.latestQuarantineHistory[0]
                                    ?.quarantine_check_comment && (
                                    <div style={{fontSize:14,marginTop:8}}>
                                      {/* <br /> */}
                                      {
                                        set.sets.latestQuarantineHistory[0]
                                          .quarantine_check_comment
                                      }
                                    </div>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <div></div>
                          )}
                        </td>

                        <td style={{ minHeight: "44px" }}></td>
                        {/* <td>
                            {
                              set?.sets?.status === "Active"
                                ? "Active"
                                : set?.sets?.status === "Pending"
                                ? "Pending"
                                : "Deactive"
                            }
                        </td> */}

                        <td>
                          <div className="">
                            <span style={{ fontSize: "14px" }}>
                            {set?.sets?.receivedByUser?.length > 0
                              ? `${set.sets.receivedByUser[0].first_name} ${set.sets.receivedByUser[0].last_name}`
                              : ""}
                          
                            </span>{" "}
                            <br />
                            <span style={{ fontSize: "12px" }}>
                              {set?.sets?.receivedDate
                                ? dateFormat(set.sets.receivedDate, "mmm dS, yyyy")
                                : ""}
                            </span>
                          </div>
                        </td>
                        <td className="text-center">
                          {set?.sets?.status === "Pending" ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              
                              {/* Pending Badge */}
                              <span
                                style={{
                                  backgroundColor: "#f1eaea",
                                  color: "#6c757d",
                                  padding: "5px 12px",
                                  borderRadius: "20px",
                                  fontSize: "13px",
                                  marginBottom: "8px",
                                  display: "inline-block"
                                }}
                              >
                                Pending
                              </span>

                              {/* Approve Button */}
                             {checkApprovalPermission && (
                              <button
                                className="btn btn-primary btn-sm"
                                style={{
                                  padding: "4px 12px",
                                  fontSize: "13px"
                                }}
                                onClick={() => this.handleOpenApproveModal(set.sets)}
                              >
                                Approve
                              </button>
                              )}
                            </div>
                          ) : set?.sets?.status === "Active" ? (
                            <span style={{ fontSize: "14px" }}>Active</span>
                          //   <span style={{ fontSize: "14px" }}>
                          //   {this.state.visibility === "Approve" ? "Approved" : "Active"}
                          // </span>
                          ) : (
                            <span style={{ fontSize: "14px" }}>Deactive</span>
                          )}
                        </td>
                        <td className="text-right">
                          <div className="action-area dropdown">
                            <a
                              className="dropdown-toggle"
                              href="#"
                              id="navbarDropdown"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <span className="dots">...</span>
                            </a>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="navbarDropdown"
                            >
                              {set?.sets?.status == "Active" ? (
                                <Link
                                  className="dropdown-item"
                                  to={"/admin/edit-sets/" + set.sets._id}
                                >
                                  Edit
                                </Link>
                              ) : (
                                ""
                              )}

                              {set?.sets?.status !== "Pending" &&
                                ["Active", "Deactive"]
                                  .filter(status => status !== set?.sets?.status)
                                  .map(status => (
                                    <a
                                      key={status}
                                      className="dropdown-item"
                                      onClick={() =>
                                        this.updateVisibility(set.sets._id, status)
                                      }
                                      href="javascript:;"
                                    >
                                      {status}
                                    </a>
                                  ))
                              }

                              <a
                                className="dropdown-item"
                                onClick={(e) =>
                                  this.handleDelete(e, set.sets._id)
                                }
                                href="#"
                              >
                                Delete
                              </a>
                              <Link
                                className="dropdown-item"
                                onClick={(e) =>
                                  this.handleDownloadQuarantineHistory(
                                    e,
                                    set.sets._id,
                                    set.sets.set_name
                                  )
                                }
                              >
                                Download Quarantine History
                              </Link>
                              <Link
                                className="dropdown-item"
                                onClick={(e) =>
                                  this.handleDownloadMissingStockHistory(
                                    e,
                                    set.sets._id,
                                    set.sets.set_name
                                  )
                                }
                              >
                                Download Missing Stock History
                              </Link>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                {setsList && setsList.length == 0 && loading == false && (
                  <tr className="text-center">
                    <td colSpan="13">No Record Found</td>
                  </tr>
                )}

                {setsList && setsList.length == 0 && loading == true && (
                  <tr className="text-center">
                    <td colSpan="13">
                      <div className="loading-state-new">
                        <div className="loading"></div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {setsList && setsList.length > 0 && (
          <div>
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.limit}
              totalItemsCount={this.state.totalItemsCount}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange.bind(this)}
              itemClass="page-item"
              linkClass="page-link"
              innerClass="pagination justify-content-center mb-5"
              activeLinkClass="active"
              nextPageText="Next"
              prevPageText="Prev"
            />
          </div>
        )}

        <QuarantineModal
          isOpen={this.state.openQuarantineModal}
          onClose={this.QuarantineModalClose}
          onSubmit={this.handleQuarantineSubmit}
        />

        <MissingStockModal
          isOpen={this.state.openMissingStockModal}
          onClose={this.MissingStockModalClose}
          onSubmit={this.handleMissingStockSubmit}
        />

        <Modal
          size="md"
          backdrop="static"
          isOpen={this.state.deleteModal}
          toggle={() => this.deleteModalClose()}
        >
          <ModalHeader className="" toggle={() => this.deleteModalClose()}>
            Delete Set
          </ModalHeader>
          <ModalBody>
            <div className="my-2">
              Please confirm if you want to delete this set?
            </div>
            {this.state.error && error ? (
              <span className="text-danger">
                {error.common ? error.common : ""}
              </span>
            ) : (
              ""
            )}
          </ModalBody>
          <ModalFooter>
            <div className="">
              <button
                onClick={() => this.deleteModalClose()}
                className="btn btn-secondary mr-2"
                data-dismiss="modal"
              >
                Cancel
              </button>
              {loading == false && (
                <button className="btn btn-primary" onClick={this.doDelete}>
                  Ok
                </button>
              )}
              {loading == true && (
                <button className="btn btn-primary loader-icon" disabled>
                  <Spinner className="img-svg"></Spinner>
                </button>
              )}
            </div>
          </ModalFooter>
        </Modal>


    <Modal
      isOpen={this.state.openApproveModal}
      centered
      backdrop="static"
      keyboard={false}
      toggle={() => this.setState({ openApproveModal: false })}
    >
      <ModalHeader toggle={() => this.setState({ openApproveModal: false })}>
        Approve
      </ModalHeader>

      <ModalBody>

        {/* Checkbox */}
        <div className="mb-3">
          <label style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <Input
              type="checkbox"
              checked={this.state.receivedChecked}
              onChange={(e) =>
                this.setState({ receivedChecked: e.target.checked })
              }
            />
            Received by Warehouse
          </label>
          {this.state.errors.receivedChecked && (
            <div className="text-danger" style={{ fontSize: "13px" }}>
              {this.state.errors.receivedChecked}
            </div>
          )}
        </div>

        {/* Select User */}
        <div className="mb-3">
          <label>Set received by</label>
          <Select
            options={this.state.usersList}
            value={this.state.selectedUser}
            onChange={(selected) =>
              this.setState({ selectedUser: selected })
            }
            placeholder="Select"
          />
          {this.state.errors.selectedUser && (
            <div className="text-danger" style={{ fontSize: "13px" }}>
              {this.state.errors.selectedUser}
            </div>
          )}
        </div>

        {/* Date */}
        <div className="mb-3">
          <label>Date Received</label>
          <Input
            type="date"
            value={this.state.receivedDate}
            min={moment().format("YYYY-MM-DD")}   // ✅ restrict past dates
            onChange={(e) =>
              this.setState({ receivedDate: e.target.value })
            }
          />
          {this.state.errors.receivedDate && (
            <div className="text-danger" style={{ fontSize: "13px" }}>
              {this.state.errors.receivedDate}
            </div>
          )}
        </div>

      </ModalBody>

      <ModalFooter style={{ justifyContent: "flex-start" }}>
        <button
          className="btn btn-primary"
          style={{ minWidth: "120px" }}
          onClick={this.handleApproveSubmit}
        >
          Submit
        </button>
      </ModalFooter>
    </Modal>

        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { setsList, loading, deleteModal, refreshList, error } =
    state.rootReducer.sets;
  const { activePage, totalItemsCount, limit, redirect, checkApprovalPermission } =
    state.rootReducer.sets;

  return {
    setsList,
    loading,
    deleteModal,
    refreshList,
    activePage,
    totalItemsCount,
    limit,
    error,
    redirect,
    checkApprovalPermission,
  };
}

export default connect(mapStateToProps)(Kits);
